export const siteConfig = {
  name: "Jeevan Residency",
  shortName: "Jeevan Residency",
  address: "14/15 South Car Street,\nRameswaram,\nTamil Nadu 623526,\nIndia",
  streetAddress: "14/15 South Car Street",
  city: "Rameswaram",
  state: "Tamil Nadu",
  postalCode: "623526",
  country: "India",
  landmark: "Opposite South Gate of Ramanathaswamy Temple",
  phone: "04573222000",
  phoneHref: "tel:+04573222000",
  email: "info@jeevanresidency.com",
  whatsappNumber: "917010860069",
  whatsappLink: "https://wa.me/917010860069",
  bookingAppUrl: "https://admin.jeevanresidency.com",
  bookingUrl: "https://admin.jeevanresidency.com/booking",
  contactUrl: "https://admin.jeevanresidency.com/contact",
  manageBookingUrl: "https://admin.jeevanresidency.com/manage-booking",
  mapUrl:
    "https://maps.google.com/?q=14%2F15+South+Car+Street+Rameswaram+Tamil+Nadu+623526+India",
  embedMapUrl:
    "https://www.google.com/maps?q=14%2F15%20South%20Car%20Street%2C%20Rameswaram%2C%20Tamil%20Nadu%20623526%2C%20India&output=embed",
  siteUrl: process.env.NEXT_PUBLIC_SITE_URL || "https://jeevanresidency.com",
  coverImage:
    "/assets/jeeva-residency-top-view.jpg",
  defaultImage:
    "/assets/jeevan-residency-sea-view.jpg",
  ogImage:
    "/assets/jeevan-residency-temple-view.jpg",
};

export const navItems = [
  { href: "/", label: "Home" },
  { href: "/about", label: "About" },
  { href: "/rooms", label: "Rooms" },
  { href: "/facilities", label: "Facilities" },
  { href: "/gallery", label: "Gallery" },
  { href: "/videos", label: "Videos" },
  { href: "/rameswaram", label: "Rameswaram" },
  { href: "/offers", label: "Offers" },
  { href: "/reviews", label: "Reviews" },
  { href: "/blog", label: "Blog" },
  { href: "/contact", label: "Contact", externalHref: siteConfig.contactUrl },
];

export const tourismResources = [
  {
    label: "Rameswaram — Tamil Nadu Tourism",
    href: "https://www.tamilnadutourism.tn.gov.in/destinations/rameswaram",
    source: "Tamil Nadu Tourism",
  },
  {
    label: "Rameswaram — Incredible India",
    href: "https://www.incredibleindia.gov.in/en/tamil-nadu/rameswaram",
    source: "Ministry of Tourism, Government of India",
  },
  {
    label: "Ramanathaswamy Temple — Incredible India",
    href: "https://www.incredibleindia.gov.in/en/tamil-nadu/rameswaram/sri-ramanathaswamy-temple",
    source: "Ministry of Tourism, Government of India",
  },
];

export const rameswaramGuideLinks = [
  { label: "Rameswaram travel guide", href: "/rameswaram" },
  { label: "Places to visit", href: "/rameswaram/places-to-visit" },
  { label: "Ramanathaswamy Temple", href: "/rameswaram/ramanathaswamy-temple" },
  { label: "Pamban Bridge", href: "/rameswaram/pamban-bridge" },
  { label: "Dhanushkodi", href: "/rameswaram/dhanushkodi" },
  { label: "Hotel location", href: "/location" },
];

export const features = [
  "Temple Proximity",
  "Temple Tower View",
  "Sea View",
  "Fishing Fort View",
  "Spacious Rooms",
  "Air Conditioning",
  "Free Wi‑Fi",
  "Modern Facilities",
  "Family-Friendly Stay",
  "Convenient Location",
];

export const rooms = [
  {
    slug: "deluxe-room",
    bookingSlug: "deluxe-room",
    name: "Deluxe Room",
    subtitle: "Comfortable room with temple-town views",
    description:
      "Thoughtfully designed for restful stays near the temple, with comfortable bedding, a bright layout and practical amenities for weary travellers and family groups.",
    size: "240 sq ft",
    bed: "Queen Bed",
    capacity: "2 Adults + 1 Child",
    amenities: ["Air conditioning", "Free Wi‑Fi", "Private bath", "Desk space"],
    image:
      "/assets/jeevan-residency-sea-view.jpg",
    gallery: [
      "/assets/jeevan-residency-family-room.jpg",
      "/assets/jeevan-residency-triple-bed.jpg",
      "/assets/jeevan-residency-temple-view.jpg",
    ],
    priceLabel: "From ₹2,400/night",
  },
  {
    slug: "family-room",
    bookingSlug: "standard-room",
    name: "Family Room",
    subtitle: "Spacious room for family stays and temple visits",
    description:
      "A welcoming room with a flexible layout for families, offering additional comfort and practical storage for luggage, essentials and travel gear.",
    size: "320 sq ft",
    bed: "King Bed + Extra Bed",
    capacity: "4 Guests",
    amenities: ["Air conditioning", "Free Wi‑Fi", "Family seating", "Hot water"],
    image:
      "/assets/jeevan-residency-family-room.jpg",
    gallery: [
      "/assets/jeevan-residency-triple-bed.jpg",
      "/assets/triple-bed-family.jpg",
      "/assets/triple-bed-room.jpg",
    ],
    priceLabel: "From ₹3,200/night",
  },
  {
    slug: "premium-family-suite",
    bookingSlug: "premium-room",
    name: "Premium Family Suite",
    subtitle: "Roomy accommodation for longer stays and group travel",
    description:
      "Ideal for families or small groups seeking extra space, a calm ambience and a convenient base for local sightseeing and temple visits.",
    size: "420 sq ft",
    bed: "Two Double Beds",
    capacity: "4 Adults",
    amenities: ["Air conditioning", "Free Wi‑Fi", "Lounge area", "Room service"],
    image:
      "/assets/jeevan-residency-premium-suite.jpg",
    gallery: [
      "/assets/jeeven-residency-premium-room.jpg",
      "/assets/jeeven-residency-premium-bed.jpg",
      "/assets/primium-family-room.jpg",
    ],
    priceLabel: "From ₹4,200/night",
  },
];

export function getBookingUrl(room) {
  const roomSlug = typeof room === "string" ? room : room?.bookingSlug;
  const url = new URL(siteConfig.bookingUrl);

  if (roomSlug) {
    url.searchParams.set("room", roomSlug);
  }

  return url.toString();
}

export function getRoomBySlug(slug) {
  return rooms.find((room) => room.slug === slug);
}

export const galleryImages = [
  {
    src: "/assets/jeeva-residency-top-view.jpg",
    alt: "Jeevan Residency hotel exterior in Rameswaram",
    title: "Hotel Exterior",
    category: "Hotel",
  },
  {
    src: "/assets/jeevan-residency-deluxe-room.jpg",
    alt: "Deluxe room at Jeevan Residency Rameswaram",
    title: "Deluxe Room",
    category: "Rooms",
  },
  {
    src: "/assets/jeevan-residency-temple-view.jpg",
    alt: "Temple view from hotel at Rameswaram",
    title: "Temple View",
    category: "Temple View",
  },
  {
    src: "/assets/jeevan-residency-beach-view.jpg",
    alt: "Sea view at Rameswaram beach near Jeevan Residency",
    title: "Sea View",
    category: "Sea View",
  },
  {
    src: "/assets/jeevan-residency-family-room.jpg",
    alt: "Family room in Jeevan Residency",
    title: "Family Room",
    category: "Facilities",
  },
  {
    src: "/assets/jeevan-residency-lobby.jpg",
    alt: "Hotel lobby with modern facilities at Jeevan Residency",
    title: "Lobby",
    category: "Hotel",
  },
];

export const videos = [
  {
    title: "Hotel Tour at Jeevan Residency",
    description: "A quick look at the welcoming ambience, rooms and surroundings of the property.",
    category: "Hotel Tour",
    duration: "2:41",
    thumbnail:
      "/assets/jeeva-residency-top-view.jpg",
    url: "https://youtube.com/shorts/8OwnBWp0f-c?si=vU7k2oFBnIrNfXKs",
  },
  {
    title: "Room Experience",
    description: "A glimpse into the comfortable stays available for families and travellers.",
    category: "Rooms",
    duration: "1:54",
    thumbnail:
      "/assets/jeevan-residency-deluxe-room.jpg",
    url: "https://youtube.com/shorts/g4mSbvrMPaY?si=7sBuRuu2ygc-4EsC",
  },
  {
    title: "Rameswaram Highlights",
    description: "Explore the town, the temple and the coastal charm that surround the hotel.",
    category: "Rameswaram",
    duration: "3:12",
    thumbnail:
      "/assets/jeevan-residency-beach-view.jpg",
    url: "https://youtube.com/shorts/8OwnBWp0f-c?si=vU7k2oFBnIrNfXKs",
  },
];

export const facilities = [
  {
    title: "Air-Conditioned Rooms",
    description: "Comfortable rooms designed for a cool and restful stay in the temple town.",
    icon: "❄️",
  },
  {
    title: "Free Wi‑Fi",
    description: "Stay connected while planning temple visits, travel and local sightseeing.",
    icon: "📶",
  },
  {
    title: "Modern Room Facilities",
    description: "Thoughtfully arranged bedding, storage and essentials for a smooth trip.",
    icon: "🛏️",
  },
  {
    title: "Spacious Rooms",
    description: "Comfortable living spaces suitable for families, couples and pilgrims.",
    icon: "🏡",
  },
  {
    title: "Family-Friendly Accommodation",
    description: "Practical amenities and room layouts that suit extended family stays.",
    icon: "👨‍👩‍👧‍👦",
  },
  {
    title: "Temple View",
    description: "Many rooms are positioned to enjoy a serene temple-town atmosphere and skyline views.",
    icon: "🕌",
  },
  {
    title: "Sea View",
    description: "A charming coastal setting gives guests an experience of the region's seaside appeal.",
    icon: "🌊",
  },
  {
    title: "Fishing Fort View",
    description: "Enjoy a distinctive local perspective while staying within the historic town area.",
    icon: "⚓",
  },
];

export const faqs = [
  {
    question: "Where is Jeevan Residency located?",
    answer:
      "Jeevan Residency is located at 14/15 South Car Street, Rameswaram, Tamil Nadu 623526, India, opposite the South Gate of Ramanathaswamy Temple.",
  },
  {
    question: "How close is Jeevan Residency to Ramanathaswamy Temple?",
    answer:
      "The property is positioned close to the temple area and is convenient for visitors walking or travelling short distances to the temple.",
  },
  {
    question: "Does Jeevan Residency have air-conditioned rooms?",
    answer:
      "Yes, the hotel offers air-conditioned rooms as part of its room facilities for guest comfort.",
  },
  {
    question: "Does the hotel provide free Wi‑Fi?",
    answer:
      "Yes, free Wi‑Fi is available for guests staying at Jeevan Residency.",
  },
  {
    question: "Is Jeevan Residency suitable for families?",
    answer:
      "Yes, the accommodation is designed with family-friendly room options and practical amenities for family travel.",
  },
  {
    question: "How can I book a room?",
    answer:
      "You can use the booking page on this website or contact the property directly to enquire about room availability and reservations.",
  },
];

export const reviews = [
  {
    name: "S. Meena",
    rating: 5,
    review:
      "The location was very convenient for our temple visit, and the rooms were clean and comfortable. The staff were helpful and the stay felt easy and relaxed.",
    date: "April 2025",
  },
  {
    name: "K. Aravind",
    rating: 4,
    review:
      "A practical and comfortable stay close to the temple area. We appreciated the family-friendly setup and the easy access to local attractions.",
    date: "March 2025",
  },
  {
    name: "A. Nadhiya",
    rating: 5,
    review:
      "Good location, simple check-in process and a calm ambience. It was a convenient base for our trip around Rameswaram.",
    date: "January 2025",
  },
];

export const travelAttractions = [
  {
    name: "Ramanathaswamy Temple",
    description:
      "A prominent pilgrimage destination and one of the most visited spiritual landmarks in Rameswaram, known for its rich religious heritage and temple precincts.",
    whyVisit: "Visit for the temple's historical importance and its central role in the region's spiritual life.",
    image:
      "/assets/jeevan-residency-temple-view.jpg",
  },
  {
    name: "Pamban Bridge",
    description:
      "A famous coastal rail bridge that connects the mainland with the region beyond and offers striking views across the sea.",
    whyVisit: "Enjoy a memorable journey and scenic coastline views while exploring the area.",
    image:
      "/assets/jeevan-residency-pamban-bridge.jpg",
  },
  {
    name: "Dhanushkodi",
    description:
      "A historically significant coastal destination known for its dramatic landscape and wide-open sea views.",
    whyVisit: "Ideal for visitors interested in coastal scenery and regional history.",
    image:
      "/assets/jeevan-residency-dhanuskodi.jpg",
  },
  {
    name: "A.P.J. Abdul Kalam Memorial",
    description:
      "A well-known memorial recognising a respected leader associated with the region and its cultural heritage.",
    whyVisit: "A meaningful stop for those interested in local history and national heritage.",
    image:
      "/assets/dr-apj-abdul-kalam-national-memorial-rameswaram-tourist-jeevan-gold.jpg",
  },
  {
    name: "Ariyaman Beach",
    description:
      "A popular seafront destination where visitors can unwind and enjoy the coastline of the region.",
    whyVisit: "A suitable place for a relaxed walk, beach views and family outings.",
    image:
      "/assets/jeevan-residency-ariyaman-beach.jpg",
  },
];

export const offers = [
  {
    title: "Family Stay Support",
    description: "Practical assistance for family travellers planning a temple visit and local sightseeing in Rameswaram.",
    validFor: "Subject to room availability",
    terms: "Reservations are subject to confirmation and room availability.",
    image:
      "/assets/jeevan-residency-family-room.jpg",
  },
  {
    title: "Temple Visit Convenience",
    description: "Stay close to the temple area and plan your spiritual trip with a comfortable base.",
    validFor: "Available throughout the season",
    terms: "Offer details may vary by booking date and room category.",
    image:
      "/assets/jeevan-residency-temple-south-gate.jpg",
  },
];

export const faqPageSchema = {
  title: "Frequently Asked Questions",
};
